module.exports = __webpack_public_path__ + "img/89.5.COD.2f046eeb.png";